import { defaultTransformValue, isCSSVariableName, readTransformValue, transformProps, } from "motion-dom";
import { measureViewportBox } from "../../projection/utils/measure";
import { DOMVisualElement } from "../dom/DOMVisualElement";
import { buildHTMLStyles } from "./utils/build-styles";
import { renderHTML } from "./utils/render";
import { scrapeMotionValuesFromProps } from "./utils/scrape-motion-values";
export function getComputedStyle(element) {
    return window.getComputedStyle(element);
}
export class HTMLVisualElement extends DOMVisualElement {
    constructor() {
        super(...arguments);
        this.type = "html";
        this.renderInstance = renderHTML;
    }
    readValueFromInstance(instance, key) {
        if (transformProps.has(key)) {
            return this.projection?.isProjecting
                ? defaultTransformValue(key)
                : readTransformValue(instance, key);
        }
        else {
            const computedStyle = getComputedStyle(instance);
            const value = (isCSSVariableName(key)
                ? computedStyle.getPropertyValue(key)
                : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint }) {
        return measureViewportBox(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        buildHTMLStyles(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return scrapeMotionValuesFromProps(props, prevProps, visualElement);
    }
}
//# sourceMappingURL=HTMLVisualElement.js.map